import "admin/src/style/videoMetadataPage.css";
import { _ } from "i18n";
import client from "libs/client";
import { useLocation, useNavigate } from "react-router";
import { useToast } from "ui-kit";
import { getVideoUploadErrorMessage } from "./videoUploadErrors";

interface RetryModalProps {
    videoId: number;
    close: () => void;
}

export function RetryModal({ videoId, close }: RetryModalProps) {
    const { addSuccessToast, addErrorToast } = useToast();
    const navigate = useNavigate();
    const location = useLocation();

    const retryMutation = client.videoProcessingRetry.useMutation({
        onSuccess: () => {
            addSuccessToast("trying processing again");
            client.queryClient.invalidateQueries({
                predicate: (query) => query.queryKey.includes("metadataVideos"),
            });
            if (location.pathname !== "/video-uploads/errored") {
                navigate("/video-uploads/errored")
            }
            close();
        },
        onError: (res) => addErrorToast(getVideoUploadErrorMessage(res)),
    });

    const onSubmit = () => {
        retryMutation.mutate({ id: videoId })
    };

    return (
        <div className="approveVideoModal-container">
            <div className="approveMessage">
                Are you sure you want to retry video processing?
            </div>
            <div className="buttons">
                <div className="submit" onClick={() => onSubmit()}>
                    Retry
                </div>
                <div className="cancel" onClick={() => close()}>
                    Cancel
                </div>
            </div>
        </div>
    );
}
